var $ = jQuery;
document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.custom-ele-nav-title');
  const navOffsetTop = nav.offsetTop;
  const navHeight = nav.offsetHeight;
  const navItems = document.querySelectorAll('.custom-ele-nav-title-item');
  const contentBoxes = [];

  // 先计算全局 sticky header 的高度
  const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
  const headerHeight = header ? header.offsetHeight : 0;

  // 收集所有内容模块
  navItems.forEach((item, index) => {
    const contentBox = document.querySelector(`#custom-ele-nav-type-id${index}`);
    if (contentBox) {
      contentBoxes.push(contentBox);
    }
  });

  // 监听滚动，处理吸顶
  window.addEventListener('scroll', function () {
    if (window.scrollY >= (navOffsetTop - headerHeight)) {
      nav.classList.add('sticky');
      nav.style.top = `${headerHeight}px`; // 保证吸顶导航不会被 header 遮挡
    } else {
      nav.classList.remove('sticky');
      nav.style.top = `0px`;
    }

    updateActiveItem();
  });

  // 点击跳转逻辑
  navItems.forEach((item, index) => {
    item.addEventListener('click', function () {
      const target = document.querySelector(`#custom-ele-nav-type-id${index}`);
      const top = target.offsetTop - navHeight - headerHeight - 10; // 这里减去 header + nav 本身高度 + 间距
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      // 手动更新 active，避免动画过程中过渡
      navItems.forEach(el => el.classList.remove('active'));
      item.classList.add('active');
    });
  });

  // 滑动过程中实时更新 active 状态
  function updateActiveItem() {
    const scrollPosition = window.scrollY + navHeight + headerHeight + 20; // 提前一点触发
    let activeIndex = 0;

    contentBoxes.forEach((box, index) => {
      if (scrollPosition >= box.offsetTop) {
        activeIndex = index;
      }
    });

    navItems.forEach((item, index) => {
      item.classList.toggle('active', index === activeIndex);
    });
  }
});
